import callApi from '../../utils/api';
import { API_BASE_URL } from '../../utils/constants';
import { parseParams } from '../../utils'

const api = callApi(API_BASE_URL || "");


export const CREATE_GRADE = '/v1/api/master/gradingModel';
export const GET_GRADE_BY_ID = '/v1/api/master/gradingModel/{{id}}';
export const UPDATE_GRADE_BY_ID = `/v1/api/master/gradingModel/{{id}}`;
export const GET_GRADE_INFO = '/v1/api/master/gradingModel?{{query}}';
export const DELETE_GRADE_BY_ID = '/v1/api/master/gradingModel/{{id}}';

export const getGradeInfo = async (payload) => {

    let query = {};
    if (payload && payload.payload) {
        query = { ...payload.payload };
    }
    let params = await new URLSearchParams(query).toString();
    return await api.get(parseParams(GET_GRADE_INFO, { query: params }));
}

export const getById = async (payload) => api.get(parseParams(GET_GRADE_BY_ID, payload));
export const updateById = async (payload) => api.put(parseParams(UPDATE_GRADE_BY_ID, { id: payload.id }), payload);

export const create = async (payload) => api.post(parseParams(CREATE_GRADE), payload);
export const deleteById = async (payload) => await api.delete(parseParams(DELETE_GRADE_BY_ID, payload));




